import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import MenuItem from '@material-ui/core/MenuItem';
import './apply-form.scss';




const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    alignItems: 'center',
    textAlign:'center',
  },
}));

const currencies = [
  {
    value: 'دعوي',
    label: 'دعوي',
  },
  {
    value: 'إغاثي',
    label: 'إغاثي',
  },
  {
    value: 'صحي',
    label: 'صحي',
  },
  {
    value: 'تعليمي',
    label: 'تعليمي',
  },
  {
    value: 'اجتماعي',
    label: 'اجتماعي',
  },
  {
    value: 'تدريب ، تأهيل',
    label: 'تدريب ، تأهيل',
  },
  {
    value: 'إعلامي',
    label: 'إعلامي',
  },

];

export default function ApplyForm() {
  const classes = useStyles();
  const [currency, setCurrency] = React.useState('دعوي');

  const handleChange = (event) => {
    setCurrency(event.target.value);
  };

  return (
      <div className="apply-form">
            <Container component="main" maxWidth="xs">
                    <div className={classes.paper}>
                        <form className={classes.form} noValidate>
                        <Grid container spacing={4}>
                          
                          <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="projectName"
                                  label="مسمى المشروع "
                                  name="projectName"
                                  type="text"
                                  autoFocus
                              />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                          <TextField
                              variant="outlined"
                              margin="normal"
                              fullWidth
                              id="letterDonePDF"
                              label=" خطاب رسمي مختوم من الجهة "
                              name="letterDonePDF"
                              type="file"
                              helperText="PDF, Word , JPG file "
                          />
                       </Grid>  

                           <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="projectManager"
                                  label="مدير المشروع "
                                  name="projectManager"
                                  type="text"
                              />
                          </Grid>
                          <Grid item xs={12} sm={6}>

                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="applicantCEOPhoneNumber"
                              label="رقم جوال مدير المشروع "
                              name="applicantCEOPhoneNumber"
                              type="tel"
                              // autoComplete="phoneNumber"
                          />
                      </Grid>
                        
                           <Grid item xs={12} sm={6}>
                              <TextField
                                  // value={currency}
                                  onChange={handleChange}
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="selectField"
                                  label="مجال المشروع "
                                  name="selectField"
                                  type="select"
                                  select
                                  
                              >
                              {currencies.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                              </TextField>                
                          </Grid>
                          <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="projectCost"
                                  label="ميزانية المشروع "
                                  name="projectCost"
                                  type="number"
                              />
                          </Grid>

                          <Grid item xs={12} sm={4}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="region"
                                  label="المنطقة المستهدفه "
                                  name="region"
                                  type="text"
                                  // autoComplete="address"
                              />
                          </Grid>

                           <Grid item xs={12} sm={4}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="city"
                                  label="المدينة "
                                  name="city"
                                  type="text"
                                  // autoComplete="city"
                              />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="number"
                              label="عدد المستفيدين "
                              name="number"
                              type="number"
                          />
                      </Grid>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            variant="outlined"
                            margin="normal"
                            multiline
                            fullWidth
                            id="projectDesc"
                            rows={12}
                            label="وصف المشروع  "
                            name="projectDesc"
                            type="text"
                          />
                          </Grid>
                          <Grid item xs={12} sm={12}>
                          <TextField
                            variant="outlined"
                            margin="normal"
                            multiline
                            fullWidth
                            id="projectGoals"
                            rows={12}
                            label="أهداف المشروع  "
                            name="projectGoals"
                            type="text"
                          />
                          </Grid>
                 </Grid>
                        
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                            >
                            تقديم الطلب   
                          </Button>              
                      </form>
                    </div>
                
            </Container>
    </div>
  );
}